<template>
  <main class="home">
    <nav>
      <button class="nav-button" v-bind:class="{'is-active': navContent}" @click="navContent = !navContent;"><span class="nav-icon"></span></button>
      <transition name="fade">
        <div class="nav" v-show="navContent">
          <div class="nav-content">
            <img src="@/assets/img/nav-4th.png" loading="lazy" alt="4周年記念情報">
            <ul class="nav-list">
              <li><a class="nav-link" href="#update" @click="navContent = !navContent;"><img src="@/assets/img/nav-4th-update.png" loading="lazy" alt="超大型アップデート&amp;イベント"></a></li>
              <li><a class="nav-link" href="#pack" @click="navContent = !navContent;"><img src="@/assets/img/nav-4th-pack.png" loading="lazy" alt="拡張パック〈アンタラスの憤怒〉"></a></li>
              <li><a class="nav-link" href="#reward" @click="navContent = !navContent;"><img src="@/assets/img/nav-4th-reward.png" loading="lazy" alt="4周年記念豪華報酬イベント"></a></li>
              <li><a class="nav-link" href="#present" @click="navContent = !navContent;"><img src="@/assets/img/nav-4th-present.png" loading="lazy" alt="プレゼントキャンペーン"></a></li>
              <li><a class="nav-link" href="#card" @click="navContent = !navContent;"><img src="@/assets/img/nav-4th-card.png" loading="lazy" alt="リネレボ名刺メーカー"></a></li>
              <li><a class="nav-link" href="#live" @click="navContent = !navContent;"><img src="@/assets/img/nav-4th-live.png" loading="lazy" alt="4周年記念生放送"></a></li>
            </ul>
            <div class="nav-banner">
              <router-link class="nav-link" to="/antaras/" @click="navContent = !navContent;"><img src="@/assets/img/banner-antaras.png" loading="lazy" alt="アンタラスの憤怒 詳細を見る"></router-link>
            </div>
            <div class="nav-share">
              <img src="@/assets/img/nav-share.png" loading="lazy" alt="SHARE">
              <ul>
                <li><a href="//twitter.com/share?text=リネレボ4周年特設サイト。拡張パック〈アンタラスの憤怒〉実装や4周年記念生放送の情報、リネレボ名刺メーカーなど、リネレボ4周年を記念したイベント・キャンペーン情報をお届けします！&url=https://l2.netmarble.jp/event/4th-anniversary/&hashtags=リネレボ4周年" rel="noopener" onClick="window.open(encodeURI(decodeURI(this.href)), 'twitterWindow', 'width=650, height=470, personalbar=0, toolbar=0, scrollbars=1, sizable=1'); return false;"><img src="@/assets/img/nav-twitter.png" loading="lazy" alt="Twitter"></a></li>
                <li><a href="//www.facebook.com/share.php?u=https://l2.netmarble.jp/event/4th-anniversary/" rel="noopener" onClick="window.open(encodeURI(decodeURI(this.href)), 'facebookWindow', 'width=650, height=470, personalbar=0, toolbar=0, scrollbars=1, sizable=1'); return false;"><img src="@/assets/img/nav-facebook.png" loading="lazy" alt="Facebook"></a></li>
                <li><a href="http://line.me/R/msg/text/?%E3%83%AA%E3%83%8D%E3%83%AC%E3%83%9C4%E5%91%A8%E5%B9%B4%E7%89%B9%E8%A8%AD%E3%82%B5%E3%82%A4%E3%83%88%E3%80%82%E6%8B%A1%E5%BC%B5%E3%83%91%E3%83%83%E3%82%AF%E3%80%88%E3%82%A2%E3%83%B3%E3%82%BF%E3%83%A9%E3%82%B9%E3%81%AE%E6%86%A4%E6%80%92%E3%80%89%E5%AE%9F%E8%A3%85%E3%82%844%E5%91%A8%E5%B9%B4%E8%A8%98%E5%BF%B5%E7%94%9F%E6%94%BE%E9%80%81%E3%81%AE%E6%83%85%E5%A0%B1%E3%80%81%E3%83%AA%E3%83%8D%E3%83%AC%E3%83%9C%E5%90%8D%E5%88%BA%E3%83%A1%E3%83%BC%E3%82%AB%E3%83%BC%E3%81%AA%E3%81%A9%E3%80%81%E3%83%AA%E3%83%8D%E3%83%AC%E3%83%9C4%E5%91%A8%E5%B9%B4%E3%82%92%E8%A8%98%E5%BF%B5%E3%81%97%E3%81%9F%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88%E3%83%BB%E3%82%AD%E3%83%A3%E3%83%B3%E3%83%9A%E3%83%BC%E3%83%B3%E6%83%85%E5%A0%B1%E3%82%92%E3%81%8A%E5%B1%8A%E3%81%91%E3%81%97%E3%81%BE%E3%81%99%EF%BC%81+https://l2.netmarble.jp/event/4th-anniversary/+%EF%BC%83%E3%83%AA%E3%83%8D%E3%83%AC%E3%83%9C4%E5%91%A8%E5%B9%B4" rel="noopener" onClick="window.open(encodeURI(decodeURI(this.href)), 'lineWindow', 'width=650, height=470, personalbar=0, toolbar=0, scrollbars=1, sizable=1'); return false;"><img src="@/assets/img/nav-line.png" loading="lazy" alt="LINE"></a></li>
              </ul>
            </div>
          </div>
          <div class="nav-overlay"></div>
        </div>
      </transition>
    </nav>
    <section class="hero">
      <h1><img class="hero-logo-4th" src="@/assets/img/logo-4th.png" loading="lazy" alt="4th Anniversary"></h1>
      <StoreBadge/>
      <div class="scroll">
        <span class="scroll-arrow"><span></span></span>
        <img src="@/assets/img/scroll.png" loading="lazy" alt="SCROLL">
      </div>
      <div class="hero-movie">
        <div v-if="isMobile()">
          <video autoplay loop muted playsinline>
            <source src="@/assets/video/background-sp.mp4" type="video/mp4">
          </video>
        </div>
        <div v-else>
          <video autoplay loop muted playsinline>
            <source src="@/assets/video/background-pc.mp4" type="video/mp4">
          </video>
        </div>
      </div>
    </section>
    <section id="update" class="update">
      <h2 class="update-title"><img class="sub" src="@/assets/img/update-title01.png" loading="lazy" alt="4TH ANNIVERSARY"><img src="@/assets/img/update-title02.png" loading="lazy" alt="超大型アップデート"></h2>
      <p class="update-text"><strong>皆様に支えられてリネレボは4周年を迎えます！</strong><br>
      更なる進化を続けるリネレボを是非お楽しみください。</p>
      <ul class="update-list">
        <li class="white">
          <img class="no" src="@/assets/img/update-update01.png" loading="lazy" alt="UPDATE 1">
          <div class="update-list-text">
            <p>拡張パック<br>
            <strong class="blue">〈アンタラスの憤怒〉</strong><br>
            実装</p>
          </div>
        </li>
        <li class="white">
          <img class="no" src="@/assets/img/update-update02.png" loading="lazy" alt="UPDATE 2">
          <div class="update-list-text">
            <p>新アガシオン<br>
            <strong>アンタラス<br>
            アンタラス討伐隊</strong><br>
            登場</p>
          </div>
        </li>
        <li class="white">
          <img class="no" src="@/assets/img/update-update03.png" loading="lazy" alt="UPDATE 3">
          <div class="update-list-text">
            <p>新アイテム<br>
            <strong>武器コスチューム<br>
            アーティファクト<br>
            エンチャントボード<br>
            マント</strong>登場</p>
          </div>
        </li>
        <li class="purple">
          <img class="no" src="@/assets/img/update-event01.png" loading="lazy" alt="EVENT 1">
          <div class="update-list-text">
            <p>エリカガイド<br>
            <strong class="pink">ZR武器進化材料</strong>や<br>
            <strong class="pink">+40強化スクロール</strong>or<br>
            <strong class="pink">覚醒3LRアンデッド装備</strong>を<br>
            手に入れよう！</p>
          </div>
        </li>
        <li class="purple">
          <img class="no" src="@/assets/img/update-event02.png" loading="lazy" alt="EVENT 2">
          <div class="update-list-text">
            <p>4周年大当たりガチャ<br>
            <strong class="pink">アンタラス<br>
            スペシャルボックス</strong>や<br>
            豪華報酬が当たる！</p>
          </div>
        </li>
        <li class="purple">
          <img class="no" src="@/assets/img/update-event03.png" loading="lazy" alt="EVENT 3">
          <div class="update-list-text">
            <p>アンタラスキャッチ<br>
            新ミニゲームで<br>
            <strong>拡張パック用アイテム</strong>を<br>
            GET</p>
          </div>
        </li>
        <li class="purple">
          <img class="no" src="@/assets/img/update-event04.png" loading="lazy" alt="EVENT 4">
          <div class="update-list-text">
            <p>4周年前夜祭<br>
            <strong class="pink">LRアーティファクト</strong>や<br>
            <strong>魔力石強化クリスタル</strong>を<br>
            手に入れよう！</p>
          </div>
        </li>
        <li class="purple">
          <img class="no" src="@/assets/img/update-event05.png" loading="lazy" alt="EVENT 5">
          <div class="update-list-text">
            <p>新要塞戦トーナメント<br>
            <strong>New Generations Cup<br>
            開催中！</strong><br>
            4周年生放送で決勝戦配信</p>
          </div>
        </li>
      </ul>
    </section>
    <section id="pack" class="pack">
      <h2 class="pack-title"><img class="sub" src="@/assets/img/pack-title01.png" loading="lazy" alt="拡張パック"><img class="logo" src="@/assets/img/pack-title02.png" loading="lazy" alt="アンタラスの憤怒"><img class="text" src="@/assets/img/pack-title03.png" loading="lazy" alt="実装"></h2>
      <p class="pack-text">ゲーム本編とは別の世界が新しく実装されます。<br>
      拡張パック専用キャラクターを育成して、<br>
      高難易度のレイドボスに挑みましょう！</p>
      <div class="pack-banner">
        <router-link to="/antaras/"><img src="@/assets/img/banner-antaras.png" loading="lazy" alt="アンタラスの憤怒 詳細を見る"></router-link>
      </div>
      <p class="pack-text">既存・復帰・新規の垣根なく<strong>最大25人での協力プレイ</strong>が<span class="br"></span>可能です。</p>
    </section>
    <section id="reward" class="reward">
      <h2 class="reward-title"><img src="@/assets/img/reward-title.png" loading="lazy" alt="4周年記念豪華報酬イベント"></h2>
      <p class="reward-text">4周年を記念して超豪華ゲーム内報酬が獲得できるイベントや<br>
      アンタラスグッズ獲得チャンスのあるイベントなど多数開催！</p>
      <div class="reward-box">
        <div class="reward-left">
          <h3 class="reward-subtitle01"><img src="@/assets/img/reward-subtitle01.png" loading="lazy" alt="4周年記念エリカガイド"></h3>
          <picture>
            <source media="(min-width: 829px)" srcset="@/assets/img/reward-box01-pc.png">
            <img src="@/assets/img/reward-box01-sp.png" loading="lazy" alt="簡単なミッションクリアで超豪華報を獲得！">
          </picture>
        </div>
        <div class="reward-right">
          <h3 class="reward-subtitle02"><img src="@/assets/img/reward-subtitle02.png" loading="lazy" alt="大当たりガチャ"></h3>
          <picture>
            <source media="(min-width: 829px)" srcset="@//assets/img/reward-box02-pc.png">
            <img src="@/assets/img/reward-box02-sp.png" loading="lazy" alt="ウェブイベント、既存のリサイクル、ヒットテーマに変更">
          </picture>
          <h3 class="reward-subtitle03"><img src="@/assets/img/reward-subtitle03.png" loading="lazy" alt="生放送抽選"></h3>
          <picture>
            <source media="(min-width: 829px)" srcset="@//assets/img/reward-box03-pc.png">
            <img src="@/assets/img/reward-box03-sp.png" loading="lazy" alt="アンタラスギフトボックス">
          </picture>
        </div>
      </div>
      <a class="reward-button not" href=""><img src="@/assets/img/button-detail.png" loading="lazy" alt="詳細を見る"></a>
    </section>
    <section id="present" class="present">
      <h2 class="present-title"><img src="@/assets/img/present-title.png" loading="lazy" alt="プレゼントキャンペーン"></h2>
      <p class="present-text">拡張パック〈アンタラスの憤怒〉実装記念グッズを制作しました！<br>
      スペシャルボックスの中には、<strong>「キャラクターカード」</strong>や<strong>「名刺入れ」</strong><br>
      さらに<strong>「限定ブレスレット」</strong>等が入っています。<br>
      ゲーム内イベントや４周年記念生放送のキャンペーンに<br>
      ご応募いただいた方の中から抽選でプレゼント！</p>
      <img class="present-img" src="@/assets/img/present-img.png" loading="lazy" alt="8/9(月)生放送時に紹介！">
      <a class="present-button" href="//forum.netmarble.com/lin2jp/view/16/5982" rel="noopener"><img src="@/assets/img/button-detail.png" loading="lazy" alt="詳細を見る"></a>
    </section>
    <section id="card" class="card">
      <h2 class="card-title"><img src="@/assets/img/card-title.png" loading="lazy" alt="リネレボ名刺メーカー"></h2>
      <img class="card-sample sample01" src="@/assets/img/card-sample01.png" loading="lazy" alt="">
      <img class="card-sample sample02" src="@/assets/img/card-sample02.png" loading="lazy" alt="">
      <p class="card-text">記念グッズに合わせて名刺メーカーをご用意しました。<br>
      Twitterにも投稿できますので、<br>
      フレンドや血盟探しにご活用ください。<br>
      <a href="https://twitter.com/search?q=%23%E3%83%AA%E3%83%8D%E3%83%AC%E3%83%9C%E5%90%8D%E5%88%BA%E3%83%A1%E3%83%BC%E3%82%AB%E3%83%BC" target="_blank" rel="noopener">#リネレボ名刺メーカー</a></p>
      <div class="card-form">
        <span class="text">サーバー名</span>
        <div class="select">
          <select v-model="serverName" ref="serverName">
            <option hidden>選択してください</option>
            <option value="イアナ">イアナ</option>
            <option value="エリキア">エリキア</option>
            <option value="エルカーディア">エルカーディア</option>
            <option value="エルフィナ">エルフィナ</option>
            <option value="カーディア">カーディア</option>
            <option value="ケンオーウェン">ケンオーウェン</option>
            <option value="スローン">スローン</option>
            <option value="セレシン">セレシン</option>
            <option value="タルカイ">タルカイ</option>
            <option value="トール">トール</option>
            <option value="フェイシャル">フェイシャル</option>
            <option value="リトラ">リトラ</option>
          </select>
        </div>
        <span class="text">キャラクター名</span>
        <div class="input">
          <input type="text" v-model="charName" ref="charName" maxlength="12">
        </div>
        <span class="text">クラス名</span>
        <div class="select">
          <select v-model="className" ref="className">
            <option hidden>選択してください</option>
            <option value="フェニックスナイト">フェニックスナイト</option>
            <option value="ドレッドノート">ドレッドノート</option>
            <option value="アドベンチャラー">アドベンチャラー</option>
            <option value="サジタリウス">サジタリウス</option>
            <option value="アークメイジ">アークメイジ</option>
            <option value="カーディナル">カーディナル</option>

            <option value="エヴァステンプラー">エヴァステンプラー</option>
            <option value="ソードミューズ">ソードミューズ</option>
            <option value="ウィンドライダー">ウィンドライダー</option>
            <option value="ムーンライトセンティネル">ムーンライトセンティネル</option>
            <option value="ミスティックミューズ">ミスティックミューズ</option>
            <option value="エヴァスセイント">エヴァスセイント</option>

            <option value="シリエンテンプラー">シリエンテンプラー</option>
            <option value="スペクトラルダンサー">スペクトラルダンサー</option>
            <option value="ゴーストハンター">ゴーストハンター</option>
            <option value="ゴーストセンティネル">ゴーストセンティネル</option>
            <option value="ストームスクリーマー">ストームスクリーマー</option>
            <option value="シリエンセイント">シリエンセイント</option>

            <option value="エターナルガーディアン">エターナルガーディアン</option>
            <option value="ウォースレイヤー">ウォースレイヤー</option>
            <option value="バウンティハンター">バウンティハンター</option>
            <option value="ウォースミス">ウォースミス</option>
            <option value="エルドリッヂウィザード">エルドリッヂウィザード</option>
            <option value="マスターセイジ">マスターセイジ</option>

            <option value="デストロイヤー">デストロイヤー</option>
            <option value="タイラント">タイラント</option>
            <option value="ウォークライヤー">ウォークライヤー</option>
            
            <option value="ドゥームブリンガー">ドゥームブリンガー</option>
            <option value="トリックスター">トリックスター</option>
            <option value="ソウルハウンド">ソウルハウンド</option>
            
          </select>
        </div>
        <span class="text">血盟名</span>
        <div class="input">
          <input type="text" v-model="guildName" ref="guildName" maxlength="16">
        </div>
        <span class="text">役職名</span>
        <div class="input">
          <input type="text" v-model="levelName" ref="levelName" maxlength="10">
        </div>
        <p class="error" v-show="inputChcek"><span>!</span>未入力の欄があります</p>
      </div>
      <div class="card-terms">
        <p class="card-terms-title">利用規約</p>
        <p>『リネージュ2 レボリューション』リネレボ名刺メーカーをご利用の際は、以下に定める同意事項に同意の上、ご利用ください。</p>
        <ul>
          <li>1. 『リネージュ2 レボリューション』リネレボ名刺メーカーの自由入力欄にて入力したメッセージの著作権その他知的財産権は、当該メッセージを投稿した利用者が保有するものとします。但し、ネットマーブル株式会社（以下、「当社」といいます）は当該メッセージをアプリの提供、広告宣伝又はプロモーションを目的とする範囲内にて、当社が必要と判断する処理を行った上で、当社及び当社と提携するWebサイトその他媒体にて利用できるものとします。利用者は、本項に基づく当社のメッセージの利用に対し、著作者人格権を行使しないものとします。</li>
          <li>2. 『リネージュ2 レボリューション』リネレボ名刺メーカー利用時に発生するインターネット接続料や通信料は、利用者の負担となります。</li>
          <li>3. 『リネージュ2 レボリューション』リネレボ名刺メーカーに関する質問、問い合わせはhelp_l2r@netmarble.jpにご連絡ください。問い合わせの際には必ず【リネレボ名刺メーカー】とわかる文言を本文中にご記載ください。</li>
          <li>4. 自由入力欄の内容が、アプリの利用規約、その他当社が定める規約及び投稿禁止事項（以下、総称して「規約等」といいます）に違反すると当社が判断する場合、当社は、利用者に通知せず入力内容を削除できるものとします。</li>
          <li>5. 当社は、違反メッセージを入力した利用者に対し、規約等に従い利用者のアカウントを停止または解除することができます。</li>
          <li>6. 当社は、利用者間のコミュニケーションに関与しません。万一利用者間の紛争があった場合でもその責任を負わず当該利用者間で解決するものとし、利用者は、当社、本アプリの運営チームならびに他の利用者に対し一切の迷惑をかけないものとします。</li>
          <li>7. 当社は、必要と判断した場合、利用者に通知することなくいつでも本サービスの機能変更、若しくはその提供を中止又は一時的に停止することができるものとします。</li>
        </ul>
        <p>投稿禁止事項</p>
        <ul>
          <li>1. 出会いまたは個人情報を求める行為・異性・同性問わず、出会いを求める行為・援助交際、売春・買春につながる投稿・個人情報の掲載や聞き出し</li>
          <li>2. 性的な内容の投稿・性行為描写・性的表現など全年齢にふさわしくない表現を含む投稿</li>
          <li>3. 法律に違反する行為・犯罪の実行、関与、予告に関する投稿や犯罪行為を助長する投稿・肖像権および著作権など、他人の権利を侵害する行為</li>
          <li>4. 売買など利益を得る行為・売買行為、およびそれを宣伝・告知・勧誘する行為・他サービスのアイテム・アカウント等を利用して利益を得る行為、およびそれを宣伝・告知・勧誘する行為・ねずみ講、マルチ商法、アフィリエイトなどに誘導する行為</li>
          <li>5. 誹謗中傷・他のお客様の情報を公開する内容の投稿・誹謗・中傷などを目的とした投稿</li>
          <li>6. いやがらせやいじめにあたる行為・連続投稿や荒らし投稿など他のお客様の迷惑にあたる行為・特定のお客様を通報するように扇動する行為</li>
          <li>7. 迷惑行為（勧誘、広告など）・外部サイトへ勧誘する内容を送信する行為（出会い系サイト、アフィリエイトサイト等）・営利、非営利問わず無差別に第三者を勧誘する行為</li>
          <li>8. 不正行為（ゲーム内での不正など）・不具合・ゲーム仕様にはない方法を用いたアイテム等の不正取得行為、およびそれを流布する行為</li>
          <li>9. RMT行為（リアルマネートレード）・本アプリのアイテム等を現金で売買することを目的とした投稿</li>
          <li>10. その他の規約違反・無差別にメール送信・友だち希望などの投稿をする行為・自殺予告、および誘発・助長の恐れがある投稿・本アプリの運営、または他のお客様の本アプリの利用を妨害する行為・本アプリの利用規約に記載されている禁止行為・当社関係者や運営チーム、パトロールになりすます行為・その他、当社が、合理的な理由に基づき不適切と判断する行為</li>
        </ul>
      </div>
      <p class="card-terms-check"><label><input name="terms" type="checkbox" value="" v-model="termsCheck" ref="termsCheck"><span class="box"></span>利用規約に同意する</label></p>
      <p>（名刺作成には利用規約への同意が必要です）</p>
      <button class="card-submit" v-on:click="openCard"><img src="@/assets/img/button-card.png" loading="lazy" alt="名刺を作成する"></button>
      <div class="card-modal" v-show="showContent">
        <div class="card-modal-content">
          <div class="card-img" v-bind:class="human" ref="showContent">
            <p class="card-img-name">{{charName}}</p>
            <p class="card-img-server">{{serverName}}</p>
            <p class="card-img-class">{{className}}</p>
            <p class="card-img-clan">{{guildName}}</p>
            <p class="card-img-position">{{levelName}}</p>
          </div>
          <div class="card-button">
            <button v-on:click="printCard"><img src="@/assets/img/button-download.png" loading="lazy" alt="ダウンロード"></button>
            <button class="closeCard" v-on:click="closeCard"><img src="@/assets/img/button-close.png" loading="lazy" alt="閉じる"></button>
          </div>
        </div>
        <div class="card-modal-background closeCard" v-on:click="closeCard"></div>
      </div>
      <img :src="output" ref="outimage" v-show="false">
    </section>
    <section id="live" class="live">
      <h2 class="live-title"><img src="@/assets/img/live-title.png" loading="lazy" alt="4周年記念生放送"></h2>
      <p>4周年に関する最新情報をお届けします。<br>
      NGC決勝トーナメントも生放送内にて開催！</p>
      <p class="live-date">2021年8月9日(月)19:00から放送予定</p>
      <div class="live-movie" v-on:click="openMovie">
        <button class="live-movie-play" v-on:click="openMovie"><img src="@/assets/img/live-movie-play.png" loading="lazy" alt="再生する"></button>
      </div>
      <div class="live-modal" v-show="showMovie">
        <button class="modal-close closeMovie" v-on:click="closeMovie"><span class="modal-close-icon"></span></button>
        <div class="live-modal-content">
          <iframe class="player" src="https://www.youtube.com/embed/tz0-OIRi4JE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <div class="live-modal-background closeMovie" v-on:click="closeMovie"></div>
      </div>
      <ul class="live-link">
        <li><a href="//youtu.be/tz0-OIRi4JE" target="_blank" rel="noopener"><img src="@/assets/img/live-youtube.png" loading="lazy" alt="YouTube Live"></a></li>
        <li><a href="//twitter.com/Line2Revo" target="_blank" rel="noopener"><img src="@/assets/img/live-twitter.png" loading="lazy" alt="Twitter Live"></a></li>
      </ul>
      <!-- <button class="card-submit" v-on:click="openCard"><img src="@/assets/img/button-card.png" loading="lazy" alt="名刺を作成する"></button>
      <div class="card-modal" v-show="showContent">
        <div class="card-modal-content">
          <div class="card-img" v-bind:class="human" ref="showContent">
            <p class="card-img-name">{{charName}}</p>
            <p class="card-img-server">{{serverName}}</p>
            <p class="card-img-class">{{className}}</p>
            <p class="card-img-clan">{{guildName}}</p>
            <p class="card-img-position">{{levelName}}</p>
          </div>
          <div class="card-button">
            <button v-on:click="printCard"><img src="@/assets/img/button-download.png" loading="lazy" alt="ダウンロード"></button>
            <button class="closeCard" v-on:click="closeCard"><img src="@/assets/img/button-close.png" loading="lazy" alt="閉じる"></button>
          </div>
        </div>
        <div class="card-modal-background closeCard" v-on:click="closeCard"></div>
      </div> -->
      <h3 class="live-cast"><img src="@/assets/img/live-cast.png" loading="lazy" alt="出演者"></h3>
      <ul class="live-cast-img">
        <li><img src="@/assets/img/live-cast-img01.png" loading="lazy" alt="OooDaさん"></li>
        <li><img src="@/assets/img/live-cast-img02.png" loading="lazy" alt="S嶋さん"></li>
      </ul>
      <p>放送中に指定ハッシュタグを付けてツイートすると、<br>
      OooDaさんやS嶋さんにツイートが読まれるかも…？<br>
      さらに、抽選で記念グッズもプレゼントします。<br>
      ぜひ感想や放送へのメッセージを呟いてください！<br>
      指定のハッシュタグは放送内で紹介！</p>
      <a class="live-twitter" href="//twitter.com/Line2Revo" target="_blank" rel="noopener"><img src="@/assets/img/button-twitter.png" loading="lazy" alt="公式Twitter"></a>
      <p>生放送に合わせて公式Twitterも更新します！</p>
      <div class="tournament">
        <h3 class="tournament-title"><img class="tournament-logo" src="@/assets/img/logo-ngc.png" loading="lazy" alt="NEW GENERATIONS CUP">
        <img src="@/assets/img/tournament-title.png" loading="lazy" alt="NGC決勝トーナメント"></h3>
        <img class="tournament-winner" src="@/assets/img/tournament-winner.png" loading="lazy" alt="優勝">
        <!-- <div class="tournament-rule">
          <div class="round roundB01">
            <div class="line lineAf01"><div></div></div><div class="line lineAf02"><div></div></div><div class="line lineAf03"><div></div></div><div class="line lineAf04"><div></div></div><div class="line lineAf05"><div></div></div><div class="line lineAf06"><div></div></div><div class="line lineAf07"><div></div></div><div class="line lineAf08"><div></div></div><div class="line lineAf09"><div></div></div><div class="line lineAf10"><div></div></div><div class="line lineAf11"><div></div></div><div class="line lineAf12"><div></div></div><div class="line lineAf13"><div></div></div><div class="line lineAf14"><div></div></div><div class="line lineAf15"><div></div></div><div class="line lineAf16"><div></div></div>
          </div>
          <div class="round roundB02">
            <div class="line lineAg01"><div></div></div><div class="line lineAg02"><div></div></div><div class="line lineAg03"><div></div></div><div class="line lineAg04"><div></div></div><div class="line lineAg05"><div></div></div><div class="line lineAg06"><div></div></div><div class="line lineAg07"><div></div></div><div class="line lineAg08"><div></div></div>
          </div>
          <div class="round roundB03">
            <div class="line lineAh01"><div></div></div><div class="line lineAh02"><div></div></div><div class="line lineAh03"><div></div></div><div class="line lineAh04"><div></div></div>
          </div>
          <div class="round roundB04">
            <div class="line lineAi01"><div></div></div><div class="line lineAi02"><div></div></div>
          </div>
          <div class="round roundB05">
            <div class="line lineAj01"><div></div></div>
          </div>
        </div> -->
        <div class="tournament-rule">
          <div class="round roundB01" v-html="round1"></div>
          <div class="round roundB02" v-html="round2"></div>
          <div class="round roundB03" v-html="round3"></div>
          <div class="round roundB04" v-html="round4"></div>
          <div class="round roundB05" v-html="round5"></div>
        </div>
        <div class="tournament-list">
          <div class="th">
            <p class="clanRank"><span>順位</span></p>
            <p class="clanName">血盟名</p>
            <p class="clanServer">サーバー名</p>
          </div>
          <div class="clan" v-bind:class="t_guild.winlose" v-for="t_guild in guildList" :key="t_guild.rank">
            <p class="rank">{{t_guild.rank}}</p>
            <p class="name">{{t_guild.gname}}</p>
            <p class="server">{{t_guild.sname}}</p>
          </div>
          <!--
          <div class="clan lose">
            <p class="rank">0</p>
            <p class="name">ブロック血盟名</p>
            <p class="server">サーバー名</p>
          </div>
          <div class="clan">
            <p class="rank">000</p>
            <p class="name">ブロック血盟名</p>
            <p class="server">サーバー名</p>
          </div>
          <div class="clan">
            <p class="rank"></p>
            <p class="name"></p>
            <p class="server"></p>
          </div>
          <div class="clan">
            <p class="rank"></p>
            <p class="name"></p>
            <p class="server"></p>
          </div>
          <div class="clan">
            <p class="rank"></p>
            <p class="name"></p>
            <p class="server"></p>
          </div>
          <div class="clan">
            <p class="rank"></p>
            <p class="name"></p>
            <p class="server"></p>
          </div>
          <div class="clan">
            <p class="rank"></p>
            <p class="name"></p>
            <p class="server"></p>
          </div>
          <div class="clan">
            <p class="rank"></p>
            <p class="name"></p>
            <p class="server"></p>
          </div>
          <div class="clan">
            <p class="rank"></p>
            <p class="name"></p>
            <p class="server"></p>
          </div>
          <div class="clan">
            <p class="rank"></p>
            <p class="name"></p>
            <p class="server"></p>
          </div>
          <div class="clan">
            <p class="rank"></p>
            <p class="name"></p>
            <p class="server"></p>
          </div>
          <div class="clan">
            <p class="rank"></p>
            <p class="name"></p>
            <p class="server"></p>
          </div>
          <div class="clan">
            <p class="rank"></p>
            <p class="name"></p>
            <p class="server"></p>
          </div>
          <div class="clan">
            <p class="rank"></p>
            <p class="name"></p>
            <p class="server"></p>
          </div>
          <div class="clan">
            <p class="rank"></p>
            <p class="name"></p>
            <p class="server"></p>
          </div>
          //-->
        </div>
        <p class="tournament-schedule">試合スケジュール</p>
        <p class="tournament-schedule">〈準決勝戦〉<br>
        2021年7月31日(土)<br>
        準決勝① 19:10 開始<br>
        準決勝② 19:45 開始</p>
        <p class="tournament-schedule">〈決勝戦〉<br>
        2021年8月9日(月)<br>
        20:20 開始予定</p>
      </div>
      <a class="live-button" href="//forum.netmarble.com/lin2jp/view/16/6001" rel="noopener"><img src="@/assets/img/button-detail.png" loading="lazy" alt="詳細を見る"></a>
      <h2 class="twitter-widget-title"><img src="@/assets/img/widget-title.png" loading="lazy" alt="出演者"></h2>
      <div class="twitter-widget">
        <div class="twitter-widget-inner">
          <div class="box" v-for="t_data in twitterdata" :key="t_data.idx" v-on:click="popTwitter(t_data.UserID, t_data.TwitterKey)">
            <div class="photo"><img alt="" v-if="t_data.MediaImg" :src="t_data.MediaImg"></div><div class="txt-area"><p class="user">{{t_data.NickName }}</p><p class="account">@{{t_data.UserID }}</p><p class="txt" v-html="t_data.TwitterText"></p></div>
          </div>
        </div>
      </div>
    </section>
    <section class="info">
      <div class="info-banner">
        <router-link to="/antaras/"><img src="@/assets/img/banner-antaras.png" loading="lazy" alt="アンタラスの憤怒 詳細を見る"></router-link>
      </div>
      <ul class="info-official">
        <li><a href="//l2.netmarble.jp" rel="noopener"><img src="@/assets/img/banner-official.png" loading="lazy" alt="公式サイト"></a></li>
        <li><a href="//forum.netmarble.com/lin2jp" rel="noopener"><img src="@/assets/img/banner-forum.png" loading="lazy" alt="公式フォーラム"></a></li>
      </ul>
      <img :src="output" ref="outimage" v-show="false">
    </section>
  </main>
</template>

<style lang="scss">
.is-fixed {
  overflow-y: hidden;
}

.br {
  display: block;
  @media (min-width: 829px) {
    display: none;
  }
}

.blue {
  color: #8c6ca7;
}

.pink {
  color: #ebcbd9;
}

.not {
  filter: grayscale(1);
  opacity: .7;
  pointer-events: none;
}

/* nav */

.nav-button {
  background: transparent;
  cursor: pointer;
  height: 13.8rem;
  position: fixed;
  right: 0;
  top: 0;
  width: 13.8rem;
  z-index: 101;
  @media (min-width: 829px) {
    height: 14rem;
    width: 14rem;
  }
  &:hover .nav-icon::before {
    @media (min-width: 829px) {
      width: 144.186%;
    }
  }
}

.nav-icon,
.nav-icon::before,
.nav-icon::after {
  background: #fff;
  transition: all .3s;
}

.nav-icon {
  bottom: 0;
  height: 4.348%;
  margin: auto;
  position: absolute;
  right: 32.609%;
  top: 0;
  width: 31.159%;
  &::before,
  &::after {
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    right: 0;
  }
  &::before {
    top: -366.667%;
    width: 118.605%;
  }
  &::after {
    top: 366.667%;
    width: 144.186%;
  }
  .is-active & {
    &::before,
    &::after {
      background: #0a0204;
      bottom: 0;
      top: 0;
    }
    &::before {
      transform: rotate(-45deg);
      width: 144.186%;
    }
    &::after {
      transform: rotate(45deg);
    }
  }
}

.nav,
.nav-overlay {
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
}

.nav {
  position: fixed;
  z-index: 100;
}

.nav-content {
  background: #fff;
  height: 100vh;
  margin-left: auto;
  overflow-y: scroll;
  padding: 19.2rem 6.5rem 19.2rem 6.1rem;
  position: relative;
  width: 62.2rem;
  z-index: 1;
  @media (min-width: 829px) {
    padding: 12.6rem 0 12.6rem 6.4rem;
    width: 46.8rem;
  }
}

.nav-list {
  margin-top: 2.3rem;
  @media (min-width: 829px) {
    margin-top: 1.2rem;
  }
  li {
    border-bottom: 1px solid #f5f1fe;
    @media (min-width: 829px) {
      border: 0;
    }
    ~ li {
      @media (min-width: 829px) {
        margin-top: -1rem;
      }
    }
  }
}

.nav-banner {
  margin-top: 4.3rem;
  width: 49.5rem;
  @media (min-width: 829px) {
    margin-top: 5rem;
    width: 35.3rem;
  }
}

.nav-share {
  border-top: 1px solid #e4ddf1;
  margin-top: 9.4rem;
  padding-top: 5.2rem;
  @media (min-width: 829px) {
    margin-left: -6.1rem;
    padding-top: 4.6rem;
  }
  > img {
    margin: 0 auto;
    width: 12.9rem;
    @media (min-width: 829px) {
      width: 7.9rem;
    }
  }
  ul {
    display: flex;
    justify-content: center;
    margin-top: 3.6rem;
    @media (min-width: 829px) {
      margin-top: 2.2rem;
    }
    li {
      width: 9.8rem;
      @media (min-width: 829px) {
        width: 5.9rem;
      }
      ~ li {
        margin-left: 4.3rem;
        @media (min-width: 829px) {
          margin-left: 2.6rem;
        }
      }
    }
  }
}

.nav-overlay {
  background: rgba(0, 0, 0, .6);
  position: absolute;
}

/* hero */

.hero {
  height: 143.2rem;
  position: relative;
  @media (min-width: 829px) {
    min-height: 80rem;
    height: 100vh;
  }
  &::before {
    background: url('~@/assets/img/object-home-sp.png') no-repeat 50% 0 / cover;
    content: '';
    display: block;
    height: 156.2rem;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 2;
    @media (min-width: 829px) {
      background-image: url('~@/assets/img/object-home-pc.png');
      height: 112rem;
    }
  }
}

.hero-logo-4th {
  left: calc(50% - 30.5rem);
  position: absolute;
  top: 34.2rem;
  width: 63.2rem;
  z-index: 2;
  @media (min-width: 829px) {
    left: calc(50% - 25.3rem);
    top: 15.278%;
    width: 56.8rem;
  }
}

/* scroll */

.scroll {
  bottom: 9.9rem;
  left: 0;
  margin: 0 auto;
  position: absolute;
  right: 0;
  width: 7.3rem;
  z-index: 2;
  @media (min-width: 829px) {
    bottom: 7.9rem;
    width: 4.5rem;
  }
}

.scroll-arrow {
  bottom: 2.3rem;
  height: 10rem;
  left: 0;
  margin: auto;
  overflow: hidden;
  position: absolute;
  right: 0;
  @media (min-width: 829px) {
    bottom: 17.5%;
    height: 8rem;
  }
  span {
    animation: scrollDown 1.5s infinite;
    bottom: 3.2rem;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    @media (min-width: 829px) {
      bottom: 4rem;
    }
    &::before,
    &::after {
      bottom: 0;
      content: '';
      display: block;
      margin: auto;
      position: absolute;
      right: 0;
    }
    &::before {
      background: #fff;
      height: 10rem;
      left: -.5px;
      width: 1px;
    }
    &::after {
      border-left: 1px solid #fff;
      border-bottom: 1px solid #fff;
      height: 1.9rem;
      left: 0;
      transform: rotate(-45deg);
      width: 1.9rem;
      @media (min-width: 829px) {
        height: 1.1rem;
        width: 1.1rem;
      }
    }
  }
}

@keyframes scrollDown {
  0% {
    transform: translate(0, 0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translate(0, 2rem);
    opacity: 0;
  }
}

/* movie */

.hero-movie {
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  &::before {
    background: url('~@/assets/img/movie-overlay.png') no-repeat 0 0 / 100% 100%;
    content: '';
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;
    @media (min-width: 829px) {
      background: rgba(0, 0, 0, .65);
    }
  }
  video {
    display: block;
    margin: -40% 0 0 -30%;
    width: 140%;
    @media (min-width: 829px) {
      height: 100%;
      margin: 0;
      position: absolute;
      right: 0;
      top: 0;
      width: auto;
    }
  }
}

/* update */

.update {
  background: url('~@/assets/img/update-background-sp.jpg') no-repeat 50% 0 / cover;
  padding: 16rem 0 14.3rem;
  @media (min-width: 829px) {
    background: url('~@/assets/img/update-background-pc.jpg') no-repeat 50% 0 / auto 100%;
    padding: 11.9rem 0 15.7rem;
  }
}

.update-title {
  margin-left: calc(50% - 29.25rem);
  width: 58.5rem;
  @media (min-width: 829px) {
    margin-left: calc(50% - 24.35rem);
    width: 48.7rem;
  }
  .sub {
    margin: 0 auto 1.9rem;
    width: 39.3rem;
    @media (min-width: 829px) {
      margin-bottom: 2.7rem;
      width: 31.5rem;
    }
  }
}

.update-text {
  color: #6b7475;
  margin-top: 2.4rem;
  text-align: center;
  @media (min-width: 829px) {
    margin-top: 3.1rem;
  }
}

.update-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 7.4rem;
  @media (min-width: 829px) {
    margin: 3.7rem auto 0;
    max-width: 101.2rem;
  }
  li {
    line-height: 1.2;
    padding: 5.6rem 0 6.2rem;
    position: relative;
    text-align: center;
    width: 37.1rem;
    @media (min-width: 829px) {
      padding-top: 5.1rem;
      width: 32.9rem;
    }
    &::before {
      background: url('~@/assets/img/update-box-frame.png') no-repeat 0 0 / 100% auto;
      content: '';
      display: block;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
    .no {
      margin: 0 auto .4rem;
      width: 11.2rem;
      @media (min-width: 829px) {
        width: 8.3rem;
      }
    }
    &.white {
      background: url('~@/assets/img/update-box-white.png') no-repeat 0 0 / 100% 100%;
    }
    &.purple {
      background: url('~@/assets/img/update-box-purple.png') no-repeat 0 0 / 100% 100%;
      color: #fff;
    }
  }
}

.update-list-text {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  p {
    font-size: 2.6rem;
    @media (min-width: 829px) {
      font-size: 2.2rem;
    }
    .white & {
      color: #3e4e50;
    }
  }
}

/* pack */

.pack {
  background: url('~@/assets/img/pack-background-sp.jpg') no-repeat 50% 0 / cover;
  padding: 47.1rem 0 20.4rem;
  @media (min-width: 829px) {
    background: url('~@/assets/img/pack-background-pc.jpg') no-repeat 50% 0 / auto 100%;
    padding: 10.4rem 0 9.7rem;
  }
}

.pack-title {
  .sub {
    margin-left: calc(50% - 13rem);
    width: 25.4rem;
    @media (min-width: 829px) {
      margin-left: calc(50% - 29.1rem);
      width: 19.8rem;
    }
  }
  .logo {
    margin: -3.9rem 0 0 calc(50% - 41rem);
    width: 76.1rem;
    @media (min-width: 829px) {
      margin-left: calc(50% - 52.1rem);
      width: 60.1rem;
    }
  }
  .text {
    margin: -3.4rem 0 0 calc(50% - 8.5rem);
    width: 17.4rem;
    @media (min-width: 829px) {
      margin: -3.9rem 0 0 calc(50% - 25.4rem);
      width: 13.1rem;
    }
  }
}

.pack-text {
  color: #fff;
  margin-top: 3.1rem;
  text-align: center;
  @media (min-width: 829px) {
    margin: 2.9rem 0 0 calc(50% - 47rem);
    width: 60rem;
  }
  strong {
    color: #d7c2b2;
  }
}

.pack-banner {
  margin: 5.8rem auto 0;
  width: 70.7rem;
  @media (min-width: 829px) {
    margin: 4.2rem 0 0 calc(50% - 40rem);
    width: 42.5rem;
  }
  + .pack-text {
    margin-top: 6.1rem;
    @media (min-width: 829px) {
      margin-top: 4.4rem;
    }
  }
}

/* reward */

.reward {
  background: url('~@/assets/img/reward-background-sp.jpg') no-repeat 50% 0 / cover;
  padding: 16rem 0 14.7rem;
  @media (min-width: 829px) {
    background: url('~@/assets/img/reward-background-pc.jpg') no-repeat 50% 0 / auto 100%;
    padding: 11.8rem 0 12.7rem;
  }
}

.reward-title {
  margin: 0 auto;
  width: 51.7rem;
  @media (min-width: 829px) {
    width: 43.2rem;
  }
}

.reward-text {
  color: #6b7475;
  margin-top: 2.2rem;
  text-align: center;
}

.reward-box {
  @media (min-width: 829px) {
    display: flex;
    justify-content: center;
    margin-top: 5.4rem;
  }
  h3 {
    @media (min-width: 829px) {
      text-align: center;
    }
    img {
      @media (min-width: 829px) {
        display: inline-block;
        height: 100%;
        width: auto;
      }
    }
  }
  picture {
    margin: 1.9rem auto 0;
    width: 76.5rem;
    @media (min-width: 829px) {
      margin-top: 1.1rem;
      width: 50.1rem;
    }
  }
}

.reward-left {
  margin-top: 8.2rem;
  @media (min-width: 829px) {
    margin: 0;
  }
}

.reward-right {
  margin-top: 5.5rem;
  @media (min-width: 829px) {
    margin: 0 0 0 1.8rem;
  }
}

.reward-subtitle01 {
  margin: 0 auto;
  width: 49.1rem;
  @media (min-width: 829px) {
    height: 2.8rem;
    width: auto;
  }
}

.reward-subtitle02 {
  margin: 0 auto;
  width: 46.1rem;
  @media (min-width: 829px) {
    height: 2.8rem;
    width: auto;
  }
}

.reward-subtitle03 {
  margin: 5.5rem auto 0;
  width: 39.1rem;
  @media (min-width: 829px) {
    height: 2.8rem;
    margin-top: 1rem;
    width: auto;
  }
}

.reward-button {
  display: block;
  margin: 7rem auto 0;
  width: 57.5rem;
  @media (min-width: 829px) {
    margin-top: 6rem;
    width: 46rem;
  }
}

/* present */

.present {
  background: url('~@/assets/img/present-background-sp.jpg') no-repeat 50% 0 / cover;
  padding: 16.3rem 0 26.4rem;
  position: relative;
  @media (min-width: 829px) {
    background: url('~@/assets/img/present-background-pc.jpg') no-repeat 50% 0 / auto 100%;
    padding: 14.9rem 0 11.4rem;
  }
}

.present-title {
  margin: 0 auto;
  width: 37.5rem;
  @media (min-width: 829px) {
    margin-left: calc(50% - 38.1rem);
    width: 34.6rem;
  }
}

.present-text {
  font-size: .9em;
  margin-top: 1.5rem;
  text-align: center;
  @media (min-width: 829px) {
    margin: 4.2rem 0 0 calc(50% - 47.3rem);
    width: 53rem;
  }
}

.present-img {
  margin: 6.1rem 0 0 calc(50% - 27rem);
  width: 61rem;
  @media (min-width: 829px) {
    margin: 0;
    position: absolute;
    right: calc(50% - 58rem);
    top: 15rem;
    width: 48.7rem;
  }
}

.present-button {
  display: block;
  margin: 1.9rem auto 0;
  width: 57.5rem;
  @media (min-width: 829px) {
    margin-top: 6rem;
    position: relative;
    width: 46rem;
  }
}

/* card */

.card {
  background: url('~@/assets/img/card-background01-sp.jpg') no-repeat 0 0 / 100%, url('~@/assets/img/card-background02-sp.jpg') repeat-y 0 0 / 100%;
  padding: 29rem 0 14.7rem;
  position: relative;
  @media (min-width: 829px) {
    background: url('~@/assets/img/card-background01-pc.jpg') no-repeat 50% 0 / 192rem, url('~@/assets/img/card-background02-pc.jpg') repeat-y 0 0 / 192rem;
    padding-top: 11.3rem;
  }
}

.card-title {
  margin: 0 auto;
  position: relative;
  width: 40.9rem;
  z-index: 2;
  @media (min-width: 829px) {
    margin: 0 auto;
    width: 34.3rem;
  }
}

.card-sample {
  position: absolute;
  &.sample01 {
    left: calc(50% - 14rem);
    top: -12.5rem;
    width: 72.9rem;
    z-index: 1;
    @media (min-width: 829px) {
      left: calc(50% - 57.6rem);
      top: -2.5rem;
      width: 52.8rem;
    }
  }
  &.sample02 {
    left: calc(50% - 26.4rem);
    top: -22.9rem;
    width: 68.1rem;
    @media (min-width: 829px) {
      left: calc(50% - 66.2rem);
      top: -9.7rem;
      width: 49.6rem;
    }
  }
}

.card-text {
  margin-top: 3.4rem;
  text-align: center;
  @media (min-width: 829px) {
    margin-top: 2.7rem;
  }
  a {
    border-bottom: 1px solid #93a0a5;
    color: #e6de60;
    font-weight: 700;
    display: inline-block;
    margin-top: 1.4rem;
    text-decoration: none;
  }
}

.card-form {
  background: url('~@/assets/img/card-form-background-sp.png') no-repeat 0 0 / 100% 100%;
  margin: 9.9rem auto 0;
  padding: 7.2rem 6rem 12.5rem;
  position: relative;
  width: 74rem;
  @media (min-width: 829px) {
    margin: 6rem auto 0;
    padding: 6.2rem 5.6rem 8.7rem;
    width: 69.2rem;
  }
  .text {
    color: #d9c497;
    display: block;
    font-weight: 500;
    margin-left: 2.8rem;
    @media (min-width: 829px) {
      margin-left: 1.7rem;
    }
  }
  .select,
  .input {
    position: relative;
    &::before {
      border: 1px solid #8a8777;
      bottom: 0;
      content: '';
      display: block;
      height: calc(100% - 4px);
      left: 0;
      margin: auto;
      pointer-events: none;
      position: absolute;
      right: 0;
      top: 0;
      width: calc(100% - 4px);
    }
    ~ .text {
      margin-top: 4.9rem;
      @media (min-width: 829px) {
        margin-top: 3.1rem;
      }
    }
  }
  .select {
    &::after {
      border-left: 1.25rem solid transparent;
      border-right: 1.25rem solid transparent;
      border-top: 1.3rem solid #a09d97;
      bottom: 0;
      content: '';
      display: block;
      height: 1rem;
      margin: auto;
      position: absolute;
      pointer-events: none;
      right: 4.5rem;
      top: 0;
      width: 1rem;
      @media (min-width: 829px) {
        border-left: .95rem solid transparent;
        border-right: .95rem solid transparent;
        border-top: .9rem solid #a09d97;
        right: 2rem;
      }
    }
  }
  select,
  input {
    background: rgba(14, 23, 27, .5);
    border: 1px solid #a09d97;
    border-radius: .5rem;
    color: #fff;
    display: block;
    margin-top: 3.1rem;
    padding: 3.65rem 3rem;
    width: 100%;
    @media (min-width: 829px) {
      margin-top: 1.8rem;
      padding: 2.66rem 2rem;
    }
  }
  select {
    appearance: none;
    cursor: pointer;
  }
}

.error {
  bottom: 7.2rem;
  color: #de3b2e;
  font-size: 2.4rem;
  font-weight: 500;
  left: 6rem;
  position: absolute;
  @media (min-width: 829px) {
    bottom: 5.8rem;
    font-size: 1.6rem;
    left: 5.6rem;
  }
  span {
    background: #de3b2e;
    border-radius: 50%;
    color: #fff;
    display: inline-block;
    font-size: 1.6rem;
    height: 2.2rem;
    line-height: 2.2rem;
    margin-right: .7rem;
    position: relative;
    text-align: center;
    top: -.2rem;
    width: 2.2rem;
    @media (min-width: 829px) {
      font-size: 1.12rem;
      height: 1.5rem;
      line-height: 1.5rem;
      width: 1.5rem;
    }
  }
}

.card-terms {
  background: url('~@/assets/img/card-background03.jpg') repeat-y 0 0 / 100%;
  height: 65.8rem;
  margin-top: 11.9rem;
  overflow-y: scroll;
  padding: 7.9rem 4.9rem;
  @media (min-width: 829px) {
    height: 40rem;
    margin: 7.9rem auto 0;
    padding: 2.8rem 4rem;
    max-width: 100rem;
  }
  p,
  li {
    color: rgba(173, 184, 187, .6);
    font-size: 2.4rem;
    line-height: 2;
    @media (min-width: 829px) {
      font-size: 1.6rem;
      line-height: 1.5;
    }
  }
  p,
  ul {
    margin-top: 1.5em;
  }
  li {
    margin-left: 1.2em;
    text-align: justify;
    text-indent: -1.2em;
  }
}

.card-terms-title {
  color: #fff !important;
  font-size: 3.2rem !important;
  margin-top: 0 !important;
  @media (min-width: 829px) {
    font-size: 1.8rem !important;
  }
}

.card-terms-check {
  font-size: 3.2rem;
  margin-top: 8.3rem;
  text-align: center;
  @media (min-width: 829px) {
    font-size: 2.2rem;
    margin-top: 1.4rem;
  }
  label {
    cursor: pointer;
    input {
      display: none;
      &:checked ~ .box::before {
        border-color: #fff;
      }
    }
    .box {
      background: #3a4f4d;
      display: inline-block;
      height: 4.4rem;
      margin-right: 2.6rem;
      position: relative;
      top: 1rem;
      width: 4.4rem;
      &::before {
        border-bottom: .5rem solid #617271;
        border-left: .5rem solid #617271;
        bottom: 0;
        content: '';
        height: 1.2rem;
        left: 1rem;
        margin: auto;
        position: absolute;
        top: 0;
        transition: all .3s;
        width: 2.4rem;
        transform: rotate(-45deg);
        z-index: 1;
      }
    }
  }
  + p {
    color: rgba(255, 255, 255, .6);
    font-size: 2.4rem;
    margin-top: 1.7rem;
    text-align: center;
    @media (min-width: 829px) {
      font-size: 1.8rem;
    }
  }
}

.card-submit {
  background: transparent;
  cursor: pointer;
  display: block;
  margin: 6.3rem auto 0;
  width: 57.5rem;
  @media (min-width: 829px) {
    width: 46rem;
  }
}

.card-modal {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}

.card-modal-content {
  position: relative;
  z-index: 1;
}

.card-img {
  height: 42.5rem;
  padding-top: 9rem;
  width: 72rem;
  @media (min-width: 829px) {
    max-height: 675px;
    height: 56.25vw;
    padding-top: 11.5vw;
    max-width: 1200px;
    width: 100vw;
  }
  @media (min-width: 1201px) {
    padding-top: 138px;
  }
  p {
    margin-left: 38.5rem;
    @media (min-width: 829px) {
      margin-left: 53.667vw;
    }
    @media (min-width: 1201px) {
      margin-left: 644px;
    }
  }
  &.human {
    background: url('~@/assets/img/card-img-human.jpg') no-repeat 0 0 / 100% 100%;
  }
  &.elf {
    background: url('~@/assets/img/card-img-elf.jpg') no-repeat 0 0 / 100% 100%;
  }
  &.dwarf {
    background: url('~@/assets/img/card-img-dwarf.jpg') no-repeat 0 0 / 100% 100%;
  }
  &.darkelf {
    background: url('~@/assets/img/card-img-darkelf.jpg') no-repeat 0 0 / 100% 100%;
  }
  &.orc {
    background: url('~@/assets/img/card-img-orc.jpg') no-repeat 0 0 / 100% 100%;
  }
  &.kamael {
    background: url('~@/assets/img/card-img-kamael.jpg') no-repeat 0 0 / 100% 100%;
  }
}

.card-img-name {
  color: #f3f0e9;
  font-size: 100%;
  font-weight: 700;
  transform: scale(.857, .857);
  transform-origin: bottom left;
  @media (min-width: 829px) {
    // font-size: 2.457rem;
    font-size: 3.412vw;
    transform: scale(1, 1);
  }
  @media (min-width: 1201px) {
    font-size: 41px;
  }
}

.card-img-server,
.card-img-class,
.card-img-clan,
.card-img-position {
  color: #d8d5d0;
  font-size: 100%;
  transform: scale(.571, .571);
  transform-origin: bottom left;
  white-space: nowrap;
  @media (min-width: 829px) {
    // font-size: 1.6rem;
    font-size: 2.231vw;
    transform: scale(1, 1);
  }
  @media (min-width: 1201px) {
    font-size: 26px;
  }
}

.card-img-server {
  margin-top: 1rem;
  @media (min-width: 829px) {
    margin-top: 3.833vw;
  }
  @media (min-width: 1201px) {
    margin-top: 46px;
  }
}

.card-img-class,
.card-img-clan,
.card-img-position {
  margin-top: 1rem;
  @media (min-width: 829px) {
    // margin-top: 2.7rem;
    margin-top: 3.5vw;
  }
  @media (min-width: 1201px) {
    margin-top: 42px;
  }
}

.card-button {
  @media (min-width: 829px) {
    display: flex;
    justify-content: center;
  }
  button {
    background: transparent;
    cursor: pointer;
    display: block;
    margin: 4.8rem auto 0;
    width: 57.5rem;
    @media (min-width: 829px) {
      margin: 2rem 0 0;
      width: 34.4rem;
    }
    ~ button {
      margin-top: 2.9rem;
      @media (min-width: 829px) {
        margin: 2rem 0 0 1rem;
      }
    }
  }
}

.card-modal-background {
  background: rgba(0, 0, 0, .6);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

/* live */

.live {
  background: url('~@/assets/img/live-background01.jpg') repeat-y 50% 0 / 100% 101%;
  padding-top: 16rem;
  position: relative;
  @media (min-width: 829px) {
    padding-top: 13.8rem;
  }
  &::before {
    background: url('~@/assets/img/live-background-edge.jpg') no-repeat 0 0 / 100% 100%;
    content: '';
    display: block;
    height: 6rem;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}

.live-title {
  margin: 0 auto;
  width: 55.2rem;
  @media (min-width: 829px) {
    width: 44.1rem;
  }
  + p {
    color: #6c5d54;
    font-weight: 700;
    margin-top: 3.7rem;
    text-align: center;
    @media (min-width: 829px) {
      font-weight: 400;
      margin-top: 2.4rem;
    }
  }
}

.live-date {
  background: #a39083;
  border-radius: 3.1rem;
  color: #fff;
  line-height: 6.2rem;
  margin: 2.5rem auto 0;
  text-align: center;
  width: 50.8rem;
  @media (min-width: 829px) {
    font-size: 1.6rem;
    line-height: 3.8rem;
    margin-top: .8rem;
    width: 31.7rem;
  }
}

.live-movie {
  background: url('~@/assets/img/live-movie.png') no-repeat 0 0 / 100% 100%;
  cursor: pointer;
  height: 46.9rem;
  margin: 5rem auto 0;
  position: relative;
  width: 66.5rem;
  @media (min-width: 829px) {
    height: 37.7rem;
    margin-top: 4.4rem;
    width: 54.1rem;
  }
}

.live-movie-play {
  background: transparent;
  cursor: pointer;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 34.426%;
  width: 19.398%;
}

.live-modal {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}

.modal-close {
  background: transparent;
  bottom: 0;
  cursor: pointer;
  height: 13.8rem;
  margin: auto;
  position: absolute;
  right: 0;
  top: -73vw;
  width: 13.8rem;
  z-index: 2;
  @media (max-width: 828px) and (orientation: landscape) {
    bottom: auto;
    top: 0;
  }
  @media (min-width: 829px) {
    left: calc(50% + 25rem);
    top: -68rem;
  }
}

.modal-close-icon,
.modal-close-icon::before,
.modal-close-icon::after {
  margin: auto;
  position: absolute;
}

.modal-close-icon {
  background: transparent;
  bottom: 0;
  height: 4.348%;
  right: 32.609%;
  top: 0;
  width: 31.159%;
  &::before,
  &::after {
    background: #fff;
    bottom: 0;
    content: '';
    display: block;
    height: 100%;
    top: 0;
    right: 0;
    width: 144.186%;
  }
  &::before {
    transform: rotate(-45deg);
  }
  &::after {
    transform: rotate(45deg);
  }
}

.live-modal-content {
  position: relative;
  z-index: 1;
}

.player {
  height: 56vw;
  width: 100vw;
  @media (max-width: 828px) and (orientation: landscape) {
    height: 67vh;
    width: 120vh;
  }
  @media (min-width: 829px) {
    height: 55.8rem;
    width: 100rem;
  }
}

.live-modal-background {
  background: rgba(0, 0, 0, .6);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.live-link {
  display: flex;
  justify-content: center;
  margin-top: .9rem;
  @media (min-width: 829px) {
    margin-top: 1.1rem;
  }
  li {
    width: 30.5rem;
    @media (min-width: 829px) {
      width: 21.2rem;
    }
    ~ li {
      margin-left: 2.2rem;
      @media (min-width: 829px) {
        margin-left: 1.7rem;
      }
    }
  }
}

.live-cast {
  margin: 6.7rem auto 0;
  padding-top: 8.2rem;
  position: relative;
  width: 25.1rem;
  @media (min-width: 829px) {
    margin-top: 6rem;
    padding-top: 6.1rem;
    width: 18.2rem;
  }
  &::before {
    background: url('~@/assets/img/live-line.jpg') no-repeat 0 0 / 100% 100%;
    content: '';
    display: block;
    height: .7rem;
    left: calc(50% - 50vw);
    position: absolute;
    top: 0;
    width: 100vw;
    @media (min-width: 829px) {
      left: calc(50% - 73.15rem);
      width: 146.3rem;
    }
  }
}

.live-cast-img {
  display: flex;
  justify-content: center;
  margin-top: 4.2rem;
  @media (min-width: 829px) {
    margin-top: 2.3rem;
  }
  li {
    width: 32.7rem;
    @media (min-width: 829px) {
      width: 27.1rem;
    }
    ~ li {
      @media (min-width: 829px) {
        margin-left: 1.1rem;
      }
    }
  }
  + p {
    color: #6c5d54;
    font-weight: 700;
    margin-top: 4.2rem;
    text-align: center;
    @media (min-width: 829px) {
      margin-top: 1.9rem;
    }
  }
}

.live-twitter {
  display: block;
  margin: 7.3rem auto 0;
  width: 57.5rem;
  @media (min-width: 829px) {
    margin-top: 5.3rem;
    width: 46rem;
  }
  + p {
    color: #6c5d54;
    font-weight: 700;
    margin: 3.9rem auto 10rem;
    text-align: center;
    @media (min-width: 829px) {
      margin-top: 2.1rem;
    }
  }
}

.twitter-widget-title {
  margin: 14rem auto 0;
  width: 61rem;
  @media (min-width: 829px) {
    width: 50rem;
  }
}

.twitter-widget {
  background: url('~@/assets/img/widget-background.png') no-repeat 0 0 / 100% 100%;
  height: 84.5rem;
  margin: 2rem auto 0;
  padding-top: 2.1rem;
  width: 66.5rem;
  .box {
    background: #ecebe7;
    border: 1px solid #897867;
    cursor: pointer;
    margin: 0 auto;
    padding: .8rem;
    width: 95%;
    p {
      color: #6c5d54;
      font-size: 2.4rem;
      @media (min-width: 829px) {
        font-size: 1.4rem;
      }
      &.account {
        color: #897867;
        font-size: 2.2rem;
        @media (min-width: 829px) {
          font-size: 1.2rem;
        }
      }
    }
    ~ .box {
      margin-top: 1rem;
    }
  }
}

.twitter-widget-inner {
  height: 79rem;
  margin: 0 auto;
  overflow-y: scroll;
  width: 61rem;
}

.tournament {
  background: url('~@/assets/img/live-background02.jpg') repeat-y 0 0 / 100%;
  margin-top: 10rem;
  padding: 11.4rem 0 12.5rem;
  @media (min-width: 829px) {
    padding-top: 8rem;
  }
}

.tournament-title {
  margin: 0 auto;
  width: 48.1rem;
  @media (min-width: 829px) {
    width: 35.2rem;
  }
}

.tournament-logo {
  margin: 0 auto 2.9rem;
  width: 33rem;
  @media (min-width: 829px) {
    width: 18rem;
  }
}

.tournament-winner {
  margin: 7.7rem auto 0;
  width: 44rem;
  @media (min-width: 829px) {
    margin-top: 5.4rem;
    width: 28.6rem;
  }
}

.tournament-rule {
  height: 12.9rem;
  margin-left: calc(50% - 35.3rem);
  position: relative;
  width: 75.2rem;
  @media (min-width: 829px) {
    height: 9.9rem;
    margin-left: calc(50% - 43.3rem);
    width: 91.2rem;
  }
  .round {
    display: flex;
    height: 15%;
    justify-content: space-between;
    position: absolute;
    width: 100%;
    z-index: 5;
    &.roundB01 {
      bottom: 0;
    }
    &.roundB02 {
      bottom: calc(15% - 2px);
      z-index: 4;
    }
    &.roundB03 {
      bottom: calc(30% - 2px);
      z-index: 3;
    }
    &.roundB04 {
      bottom: calc(45% - 2px);
      z-index: 2;
    }
    &.roundB05 {
      bottom: calc(60% - 2px);
      z-index: 1;
    }
  }
  .line {
    position: relative;
    width: 100%;
    &::before,
    &::after,
    div {
      background: #a49a92;
      content: '';
      display: block;
      margin: auto;
      position: absolute;
    }
    &::before,
    &::after {
      z-index: 2;
    }
    &::before,
    div {
      height: 2px;
    }
    &::before {
      left: calc(50% + 1px);
      width: 25%;
    }
    &::after {
      height: 100%;
      left: 0;
      right: 0;
      width: 2px;
    }
    div {
      left: calc(25% - 1px);
      width: calc(50% + 2px);
      z-index: 1;
    }
    &.on::before,
    &.on::after {
      background: #bb472f;
    }
  }
  [class^="round roundB"] .line::before,
  [class^="round roundB"] .line::after,
  [class^="round roundB"] .line div {
    bottom: 0;
  }
  .roundB01 .line::before,
  .roundB01 .line div {
    display: none !important;
  }
  .roundB05 .line::after {
    height: calc(308% - 3px);
    left: -5.89%;
    @media (max-width: 828px) and (orientation: landscape) {
      height: calc(296% - 3px);
    }
    @media (min-width: 829px) {
      height: calc(300% - 3px);
    }
  }
  .left::before {
    left: calc(25% - 1px);
  }
  .roundB05 .line.right.on::before {
    left: calc(46.8% + 2px);
    width: calc(27.4% + 2px);
    @media (max-width: 828px) and (orientation: landscape) {
      left: calc(47% + 2px);
    }
    @media (min-width: 829px) {
      left: calc(47% + 2px);
      width: calc(27.7% + 2px);
    }
  }
  .roundB05 .line.left.on::before {
    width: 22.055%;
  }
}

.tournament-list {
  background: #74685e;
  border: 1px solid #38291d;
  color: #a4b7da;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  font-size: 2.2rem;
  font-weight: 700;
  margin: 0 auto;
  width: 79.8rem;
  @media (min-width: 829px) {
    font-size: 1.6rem;
    width: 96rem;
  }
  .th,
  .clan {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: calc(100% / 17);
  }
  .th {
    background: #514032;
  }
  .clan {
    position: relative;
    ~ .clan {
      border-left: 1px solid #524235;
    }
    &.win {
      background: #bb472f;
      color: #fff;
      &::before {
        border: 1px solid #812b19;
        content: '';
        display: block;
        height: calc(100% + 2px);
        left: -1px;
        position: absolute;
        top: -1px;
        width: calc(100% + 2px);
        z-index: 1;
      }
      .name {
        border-color: #812b19;
      }
    }
    &.lose p {
      color: #9c9086;
    }
  }
  .clanRank,
  .clanName,
  .clanServer,
  .name,
  .server {
    display: flex;
    justify-content: center;
    align-items: center;
    writing-mode: tb-rl;
    writing-mode: vertical-rl;

  }
  .clanRank,
  .clanName,
  .clanServer {
    color: #d9ccc1;
  }
  .clanRank,
  .clanName {
    justify-content: center;
  }
  .clanRank,
  .rank {
    height: 5.7rem;
    @media (min-width: 829px) {
      height: 4.8rem;
    }
  }
  .clanName,
  .name {
    height: 28.1rem;
    @media (min-width: 829px) {
      height: 17.8rem;
    }
  }
  .clanServer,
  .server {
    font-size: 1.4rem;
    height: 13.9rem;
    padding-top: 2rem;
    @media (min-width: 829px) {
      font-size: 10px;
      height: 97px;
      transform: scale(1, 1);
    }
  }
  .rank {
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: center;
  }
  &.kamael {
    background: url('~@/assets/img/card-img-kamael.jpg') no-repeat 0 0 / 100% 100%;
  }
}

.tournament-schedule {
  color: #6c5d54;
  font-weight: 700;
  margin-top: 3.4rem;
  text-align: center;
  ~ .tournament-schedule {
    margin-top: .5em;
  }
}

.live-button {
  display: block;
  margin: 9.8rem auto 0;
  width: 57.5rem;
  @media (min-width: 829px) {
    margin-top: 6rem;
    width: 46rem;
  }
}

/* info */

.info {
  padding: 25.4rem 0 8.7rem;
  @media (min-width: 829px) {
    padding-top: 13.4rem;
  }
  .home & {
    background: url('~@/assets/img/live-background01.jpg') repeat-y 0 100% / 100%;
  }
}

.info-banner {
  margin: 0 auto;
  width: 65.1rem;
  @media (min-width: 829px) {
    width: 49.6rem;
  }
}

.info-official {
  display: flex;
  justify-content: center;
  li {
    margin-top: 6rem;
    width: 29.5rem;
    @media (min-width: 829px) {
      margin-top: 4.7rem;
      width: 23.6rem;
    }
    ~ li {
      margin-left: 4.5rem;
      @media (min-width: 829px) {
        margin-left: 3.6rem;
      }
    }
  }
}

/* transition */

.fade-leave-active,
.fade-enter-active {
  transition: opacity .3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<script>
import axios from 'axios';
import StoreBadge from '@/components/StoreBadge.vue'

const userAgent = navigator.userAgent;

export default {
  name: 'app',
  components: {
    StoreBadge
  },
  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
        if (userAgent.match(/iPhone/i) || userAgent.match(/iPad/i) || userAgent.match(/iPod/i)) {
          return 'ios'
        } else {
          return 'android'
        }
      } else {
        return false
      }
    },
    openCard: function () {
      if(this.serverName =="") {
        this.$refs.serverName.focus()
        this.inputChcek = true
      } else if(this.charName ==""){
        this.$refs.charName.focus()
        this.inputChcek = true
      } else if(this.className ==""){
        this.$refs.className.focus()
        this.inputChcek = true
      } else if(this.guildName ==""){
        this.$refs.guildName.focus()
        this.inputChcek = true
      } else if(this.levelName ==""){
        this.$refs.levelName.focus()
        this.inputChcek = true
      }
       else {
        if(this.termsCheck == true) {
          
          if (this.charName.match(/^[^\x01-\x7E\xA1-\xDF]+$/)) {
            this.charName = this.charName.substring(0,8)
          }
          const subClass = this.className
          console.log(subClass);
          if(subClass == "フェニックスナイト" ||subClass == "ドレッドノート" ||subClass == "アドベンチャラー" ||subClass == "サジタリウス" ||subClass == "アークメイジ" ||subClass == "カーディナル"){
            this.human = "human"
          } else if(subClass == "エヴァステンプラー" ||subClass == "ソードミューズ" ||subClass == "ウィンドライダー" ||subClass == "ムーンライトセンティネル" ||subClass == "ミスティックミューズ" ||subClass == "エヴァスセイント"){
            this.human = "elf"
          } else if(subClass == "シリエンテンプラー" ||subClass == "スペクトラルダンサー" ||subClass == "ゴーストハンター" ||subClass == "ゴーストセンティネル" ||subClass == "ストームスクリーマー" ||subClass == "シリエンセイント"){
            this.human = "darkelf"
          } else if(subClass == "エターナルガーディアン" ||subClass == "ウォースレイヤー" ||subClass == "バウンティハンター" ||subClass == "ウォースミス" ||subClass == "エルドリッヂウィザード" ||subClass == "マスターセイジ"){
            this.human = "dwarf"
          } else if(subClass == "デストロイヤー" ||subClass == "タイラント" ||subClass == "ウォークライヤー"){
            this.human = "orc"
          } else if(subClass == "ドゥームブリンガー" ||subClass == "トリックスター" ||subClass == "ソウルハウンド"){
            this.human = "kamael"
          }
          this.showContent = true
          this.ProfileMaker_log(this.serverName, this.charName, this.className, this.guildName, this.levelName) 
          
        } else {
          alert('名刺作成には利用規約への同意が必要です。');
          this.$refs.termsCheck.focus()
        }
      }
      
    },
    closeCard: function () {
      this.showContent = false
    },
    async printCard() {
      $('meta[name=viewport]').attr('content', '');
      const el = this.$refs.showContent;
      const options = {
        //type: 'dataURL',
        type: 'png',
        //scale: 1,
        //dpi: 400,
        windowWidth: 1200,
        windowHeight: 675,
        //width:1200,
        //height:675,
        useCORS: true,
        imageTimeout: 15000,
        allowTaint: true,
       }
      //this.output = await this.$html2canvas(el, options);
      const printCanvas = await this.$html2canvas(el, options);

      if (window.navigator.msSaveOrOpenBlob) {

        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            console.log("ios");
            
            window.navigator.msSaveOrOpenBlob(printCanvas
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream"), "myprofile.png");
        } else {
            window.navigator.msSaveOrOpenBlob(printCanvas
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream"), "myprofile.png");
        }

      } else {
          var a = document.createElement("a")
          a.style = "display: none"
          a.href = printCanvas
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream")

          if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
              console.log("ios");
              a.download = "myprofile.png"
          } else {
              a.download = "myprofile.png"
          }

          document.body.appendChild(a)
          a.click()

          setTimeout(function () {
              document.body.removeChild(a)
          }, 100)
      }

      setTimeout(function(){
        $('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1');
      }, 500);
      
    },
    popTwitter:function(uid, idx) {
      window.open('https://twitter.com/'+uid+'/status/'+idx);
    },

    ProfileMaker_log : function(server, reqchar, reqclass, reqguild, reqjob) {
      axios({
        method: 'GET',
        url : 'https://l2.netmarble.jp/event/4th-anniversary/api/ProfileMaker_Log.aspx?server='+server+'&char='+reqchar+'&class='+reqclass+'&guild='+reqguild+'&job='+reqjob+'',
      }).then((response) => {

      }).catch((ex)=> {
          console.log("ERR!!!!! : ", ex)
      })
      
    },
    openMovie: function () {
      this.showMovie = true
    },
    closeMovie: function () {
      this.showMovie = false
    }
  },
  data: function () {
    return {
      navContent: false,

      guildList: null,
      round1:"",
      round2:"",
      round3:"",
      round4:"",
      round5:"",
      showContent: false,
      inputChcek: false,

      serverName:"",
      charName:"",
      className:"",
      guildName:"",
      levelName:"",
      termsCheck:"",
      output: null,
      human:"human",
      showMovie: false,
      twitterdata: null
    }
  },
  mounted(){
    axios({
        method: 'GET',
        url : 'https://l2.netmarble.jp/event/4th-anniversary/api/',
        /*
        params : {
            page : 1,
            pagesize : 5
        }*/
    }).then((response) => {
        //console.log(response.data.data[2].roundT02B);
        const d_list = response.data.data[0].TournamentMainB_List
        this.guildList = d_list
        this.round1 = response.data.data[1].TournamentMainB
        this.round2 = response.data.data[2].roundT02B
        this.round3 = response.data.data[3].roundT03B
        this.round4 = response.data.data[4].roundT04B
        this.round5 = response.data.data[5].roundT05B
        /*
        d_list.forEach(function(value, index) {
          console.log(value.gname);
          //this.guildList = '<div class="clan ' + value.winlose + '"><p class="name">' + value.gname + '</p><p class="server"><span>' + value.sname + '</span></p><p class="rank"><span>Rank</span><br>' + value.rank +'</p></div>'
        });
        */

    }).catch((ex)=> {
        console.log("ERR!!!!! : ", ex)
    }),

    axios({
        method: 'GET',
        url : 'https://l2.netmarble.jp/event/4th-anniversary/api/twitterList.aspx',
    }).then((response) => {

      const t_list2 = response.data.data
      //console.log(response);
      this.twitterdata = t_list2
        //console.log(jsonObj);
        //const d_list = response.data.data[0].TournamentMainB_List
        //this.guildList = d_list
        //this.round1 = response.data.data[1].TournamentMainB

    }).catch((ex)=> {
        console.log("ERR!!!!! : ", ex)
    }),

    $('.nav-button, .nav-link, .card-submit, .closeCard').on('click', function () {
      if ($('body').hasClass('is-fixed')) {
      	$('body').removeClass('is-fixed');
      } else {
        $('body').addClass('is-fixed');
      }
    })
  }
}
</script>
